import { ApiClientBase } from "../framework/services/api-client-base";
import { isThisLocalhost } from "../framework/utils";
import { localhostApi } from "./localhost-api";
import * as $http from 'superagent';

class AuthApiClientClass extends ApiClientBase {
    constructor() {
        super();

        this.host = isThisLocalhost() ? localhostApi : window.location.origin;
        this.host = this.host + '/api';
    }

    public sideLoadToken(token: string) {
        this.sideLoadedToken = token;
    }
    
    protected preSendRequestAction(req: $http.SuperAgentRequest): void {
        if(!this.sideLoadedToken) { return; }
        req.set('x-storm-customer', this.sideLoadedToken);

        this.sideLoadedToken = undefined;
    }

    protected acquireToken(): Promise<string> {
        return Promise.resolve('');
    }

    private sideLoadedToken: string | undefined;
}

export const AuthApiClient = new AuthApiClientClass();